import { createSagaActionTypes } from '../../../utils/actionFactory';

export const GET_ACCOUNTS = 'GET_ACCOUNTS';
export const GET_INVOICES = 'GET_INVOICES';

export const actions = createSagaActionTypes('INVOICES', [
  GET_ACCOUNTS,
  GET_INVOICES
]);
